<template>

    <div>

        <!-- MODALS ================================================== -->
        <modal name="my-modal" height="auto" :scrollable="true">
            <div class="modal-content">
                <div class="modal-card">
                    <div class="card-header">
                        <!-- Title -->
                        <h5 class="card-header-title">
                            Pengajuan Progress
                        </h5>
                    </div>
                    <form @submit.prevent="submitForm" enctype="multipart/form-data">
                        <div class="card-body">
                            <input v-model="form.id_tahapan" type="hidden">
                            <input v-model="form.id_kemajuan" type="hidden">
                            <div class="form-group">
                                <label>Tanggal<span class="text-danger">*</span></label>
                                <datetime-picker  v-model="form.tanggal" :config="{timeZone: 'Asia/Jakarta'}"></datetime-picker>
                            </div>
                            <div class="form-group">
                                <label>Surat Permohonan<span class="text-danger">*</span></label>
                                <input ref="fileInput" @change="uploadFile" type="file" accept="application/pdf, image/x-png,image/gif,image/jpeg" value="" class="form-control" required="" placeholder="">
                            </div>
                            <hr>
                            <div class="alert alert-info">
                                <br>
                                <b>Keterangan</b><br>
                                - File yang didukung: <b>pdf, png, jpg, jpeg </b><br>
                                - Maksimal file : <b>5 Mb</b>
                                <br>
                            </div>
                        </div>
                        <div class="card-footer border-top-0">
                            <ul class="pagination mb-0"></ul>
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-text text-muted" @click="hide_modal()">Batal</button>
                                <button v-if="loadAjukan == 0" type="submit" class="btn btn-primary">Ajukan</button>
                                <button v-if="loadAjukan == 1" type="button" disabled class="btn btn-primary">Loading...</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </modal>

         <modal name="my-logbook" height="auto" :scrollable="true">
            <div class="modal-content">
                <div class="modal-card">
                    <div class="card-header">
                        <!-- Title -->
                        <h5 class="card-header-title">
                            Upload Logbook
                        </h5>
                    </div>
                    <form @submit.prevent="submitLogbook" enctype="multipart/form-data">
                        <div class="card-body">
                            <input v-model="form.id" type="hidden">
                            <input v-model="form.id_tahapan" type="hidden">
                            <input v-model="form.id_kemajuan" type="hidden">
                            <div class="form-group">
                                <label>Logbook<span class="text-danger">*</span></label>
                                <input ref="fileLogbook" @change="uploadLogbook" type="file" accept="application/pdf, image/x-png,image/gif,image/jpeg" value="" class="form-control" required="" placeholder="">
                            </div>
                            <div v-if="file_logbook != ''" class="mt-1"><i class="fa fa-file-o mr-2"></i><a :href="$apiconfig + 'uploads/logbook/' + file_logbook" target="_blank" class="text-primary">Lihat Logbook<i class="fa fa-external-link ml-2"></i></a></div>
                            <hr>
                            <div class="alert alert-info">
                                <br>
                                <b>Keterangan</b><br>
                                - File yang didukung: <b>pdf, png, jpg, jpeg </b><br>
                                - Maksimal file : <b>5 Mb</b>
                                <br>
                            </div>
                        </div>
                        <div class="card-footer border-top-0">
                            <ul class="pagination mb-0"></ul>
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-text text-muted" @click="hide_logbook()">Batal</button>
                                <button v-if="loadLogbook == 0" type="submit" class="btn btn-primary">Simpan</button>
                                <button v-if="loadLogbook == 1" type="button" disabled class="btn btn-primary">Loading...</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </modal>

        <div class="container-fluid header-fixed">
            <div class="row justify-content-center">
                <div class="col-md-10">
                    <div class="section pt-md-5 pt-3">
                        <div class="d-block border-bottom">
                            <h3 class="text-dark">Progress Kemajuan</h3>
                            {{ print.judul }}
                        </div>

                        <!-- Formulir List Front -->
                        <div class="section pb-3 mt-3">

                            <div>
                                <!-- Show Data -->
                                <div v-if="listData.length > 0" class="row row-sm">
                                    <div v-for="(item, index) in listData" :key="index" class="col-md-3 mb-md-4 mb-3">
                                        <div class="card h-100 m-0">
                                            <div class="d-block h-100">
                                                <div class="d-flex flex-column h-100">
                                                    <div class="mb-0 flex-grow-1">
                                                        <img :src="'https://scola-uploader.sgp1.digitaloceanspaces.com/upload/14913c9dd9ccb03e585ebf97/mqdefault.jpg'" :style="'width:10'" class="card-img-top img-fluid wd-100p" alt="">
                                                        <div class="d-block p-3 mt-2">
                                                            <div class="badge badge-info">Tahap {{ index+1 }}</div>
                                                            <h5 class="text-dark mb-2 mt-1">{{ item.name }}</h5>
                                                            <div class="d-block px-3 py-2 bg-light rounded text-sm mb-2" style="border:1px red solid">
                                                                Maksimal : {{ item.next }}
                                                            </div>
                                                            <div v-if="item.pernyataan == 1" class="lh-sm lh-sm text-sm"><i class="fa fa-calendar mr-2"></i>{{ item.tanggal != '-' ? convertDate(item.tanggal) : '-' }}</div>
                                                            <div v-if="item.pernyataan == 0" class="lh-sm lh-sm text-sm"><i class="fa fa-calendar mr-2"></i>{{ item.tanggal != '-' ? onlyDate(item.tanggal) : '-' }}</div>
                                                            <div v-if="item.permohonan != null && item.permohonan != '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a :href="$apiconfig + 'uploads/permohonan/' + item.permohonan" target="_blank" class="text-primary">Surat Permohonan<i class="fa fa-external-link ml-2"></i></a></div>
                                                            <div v-if="item.permohonan == null" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">Tidak Ada Surat Permohonan</a></div>
                                                            <div v-if="item.permohonan == '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">-</a></div>
                                                            
                                                            <!-- <div v-if="item.undangan != null && item.undangan != '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a style="cursor:pointer"  @mouseover="updateUndangan(item.idDetail)" @click="generateUndangan" class="text-primary">Surat Undangan<i class="fa fa-external-link ml-2"></i></a></div> -->
                                                            <div v-if="item.undangan != null && item.undangan != '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a :href="$apiconfig + 'uploads/undangan/' + item.undangan" target="_blank" class="text-primary">Surat Undangan<i class="fa fa-external-link ml-2"></i></a></div>
                                                            <div v-if="item.undangan == null" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">Tidak Ada Surat Undangan</a></div>
                                                            <div v-if="item.undangan == '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">-</a></div>

                                                            <!--
                                                            <div v-if="item.undangan != null && item.undangan != '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a :href="$apiconfig + 'uploads/undangan/' + item.undangan" target="_blank" class="text-primary">Surat Pernyataan<i class="fa fa-external-link ml-2"></i></a></div>
                                                            <div v-if="item.pernyataan == 1" class="mt-1" ><i class="fa fa-file-o mr-2"></i><a style="cursor:pointer" @mouseover="updateSurat(item.idDetail)" @click="generateReport" class="text-primary">Surat Pernyataan<i class="fa fa-external-link ml-2"></i></a></div>
                                                            -->
                                                            <div v-if="item.pernyataan == null" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">Tidak Ada Surat Pernyataan</a></div>
                                                            <div v-if="item.pernyataan == '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">-</a></div>
                                                            
                                                            <div v-if="item.berita_acara != null && item.berita_acara != '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a :href="$apiconfig + 'uploads/berita_acara/' + item.berita_acara" target="_blank" class="text-primary">Berita Acara<i class="fa fa-external-link ml-2"></i></a></div>
                                                            <div v-if="item.berita_acara == null" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">Tidak Ada Berita Acara</a></div>
                                                            <div v-if="item.berita_acara == '-'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">-</a></div>

                                                            <div v-if="item.sertifikat != null && item.sertifikat != '-' && item.name != 'Sidang Doktor'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a :href="$apiconfig + 'uploads/sertifikat/' + item.sertifikat" target="_blank" class="text-primary">Surat Pernyataan<i class="fa fa-external-link ml-2"></i></a></div>
                                                            <div v-if="item.sertifikat == null && item.name != 'Sidang Doktor'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">Tidak Ada Surat Pernyataan</a></div>
                                                            <div v-if="item.sertifikat == '-' && item.name != 'Sidang Doktor'" class="mt-1"><i class="fa fa-file-o mr-2"></i><a class="text-muted">-</a></div>
                                                        </div>
                                                    </div>
                                                    <div class="d-block px-3 pb-3 pt-0">
                                                        <div v-if="item.next_tahapan == item.id || item.status != ''" class="row">
                                                            <div class="pl-3 pr-1" style="width:35%">
                                                                <button v-if="item.logbook == ''" class="btn btn-secondary btn-sm btn-block" @click="updateLogbook(item.id, item.idKemajuan, item.idLogbook, item.logbook)"><i class="fa fa-upload mr-2"></i>Logbook</button>
                                                                <button v-if="item.logbook != ''" class="btn btn-info btn-sm btn-block" @click="updateLogbook(item.id, item.idKemajuan, item.idLogbook, item.logbook)"><i class="fa fa-upload mr-2"></i>Logbook</button>
                                                            </div>
                                                            <div class="pr-3" style="width:65%">
                                                                <button v-if="item.status == 2" disabled class="btn btn-success btn-sm btn-block">Lulus</button>
                                                                <button v-if="item.status === 0" disabled class="btn btn-warning btn-sm btn-block">Pengajuan</button>
                                                                <button v-if="item.status === 4" disabled class="btn btn-info btn-sm btn-block">Disetujui</button>
                                                                <button v-if="item.status === ''  && item.next_tahapan == item.id && item.logbook != ''" @click="updateProgress(item.id, item.idKemajuan)" class="btn btn-outline-success btn-sm btn-block">Daftar</button>
                                                                <button v-if="item.status === ''  && item.next_tahapan == item.id && item.logbook == ''" @click="alertLogbook()" class="btn btn-outline-success btn-sm btn-block">Daftar</button>
                                                            </div>
                                                        </div>
                                                        <button v-if="item.status == ''  && item.next_tahapan != item.id " disabled class="btn alert-danger btn-block"><i class="fa fa-warning mr-2"></i>Selesaikan tahap sebelumnya!</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- TRACER STUDY -->
                                    <div class="col-md-3 mb-md-4 mb-3">
                                        <div class="card h-100 m-0">
                                            <div class="d-block h-100">
                                                <div class="d-flex flex-column h-100">
                                                    <div class="mb-0 flex-grow-1">
                                                        <img :src="'https://scola-uploader.sgp1.digitaloceanspaces.com/upload/14913c9dd9ccb03e585ebf97/mqdefault.jpg'" :style="'width:10'" class="card-img-top img-fluid wd-100p" alt="">
                                                        <div class="d-block p-3 mt-2">
                                                            <h6 class="text-center text-dark mb-2 mt-1">Pendataan</h6>
                                                            <h5 class="text-center text-dark mb-2 mt-1">TRACER STUDY</h5>
                                                            <div class="text-center d-block px-3 py-2 bg-light rounded text-sm mb-2" style="border:1px red solid">
                                                                Mohon agar di isi dengan data diri Bapak/Ibu sebagai responsen survey
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="d-block px-3 pb-3 pt-0">
                                                        <!-- Dots Status -->
                                                        <router-link v-if="profil == 0" to="/mahasiswa/tracer" class="col-12 btn btn-outline-danger">
                                                            ISI FORMULIR
                                                        </router-link>
                                                        <router-link v-if="profil == 1" to="/mahasiswa/tracer" class="col-12 btn btn-outline-warning">
                                                            PERBAHARUI FORMULIR
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- TRACER STUDY -->
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <vue-html2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="false"
                :preview-modal="true"
                :paginate-elements-by-height="1400"
                :filename="'datapendaftar_'"
                :pdf-quality="1"
                :manual-pagination="true"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="800px"
                ref="html2Pdf"
            >
                <section slot="pdf-content">
                        <div class="card-body pb-0">
                            <!-- Asal Pendaftar -->
                            <div class="d-block mb-4">
                                <div class="h6 d-block mb-4 text-center font-weight-bold pt-2 text-dark">SURAT PERNYATAAN PENYELESAIAN STUDI DOKTOR</div>
                                <div class="row">
                                    <div class="col-4"><a style="font-size:14px">Yang bertanda tangan dibawah ini</a><a class="float-right">:</a></div>
                                    <div class="col-8"></div>
                                </div>

                                <div class="row mt-1">
                                    <div class="col-4"><a style="font-size:14px">Nama</a><a class="float-right">:</a></div>
                                    <div class="col-8"><a class="text-dark" style="font-size:14px">{{ userdata.name }}</a></div>
                                </div>
                                    
                                <div class="row mt-1">
                                    <div class="col-4"><a style="font-size:14px">NIM</a><a class="float-right">:</a></div>
                                    <div class="col-8"><a class="text-dark" style="font-size:14px">{{ userdata.username }}</a></div>
                                </div>
                                    
                                <div class="row mt-1">
                                    <div class="col-4"><a style="font-size:14px">Prodi/Fakultas/Sekolah</a><a class="float-right">:</a></div>
                                    <div class="col-8"><a class="text-dark" style="font-size:14px">Doktor Teknik Sipil - FTSL</a></div>
                                </div>
                                    
                                <div class="row mt-1">
                                    <div class="col-4"><a style="font-size:14px">Judul Disertasi</a><a class="float-right">:</a></div>
                                    <div class="col-8"><a class="text-dark" style="font-size:14px">{{ print.judul }}</a></div>
                                </div>
                                    
                                <div class="row mt-3">
                                    <div class="col-4"><a style="font-size:14px">Pembimbing</a><a class="float-right">:</a></div>
                                    <div class="col-8"><a class="text-dark" style="font-size:14px">{{ print.pembimbing }}</a></div>
                                </div>
                                    
                                <div class="row mt-1">
                                    <div class="col-4"><a style="font-size:14px">Lama Studi Berjalan</a><a class="float-right">:</a></div>
                                    <div class="col-8"><a class="text-dark" style="font-size:14px">{{ print.studi_berjalan != '' ? print.studi_berjalan : '-' }} Semester</a></div>
                                </div>
                                    
                                <div class="row mt-1">
                                    <div class="col-4"><a style="font-size:14px">Tahapan Lulus</a><a class="float-right">:</a></div>
                                    <div class="col-8"><a class="text-dark" style="font-size:14px">Tahapan {{ print.id_tahapan+1 }} ({{ print.tahapan }})</a></div>
                                </div>
                                    
                                <div class="row mt-1">
                                    <div class="col-4"><a style="font-size:14px">Batas Penyelesaian </a><a class="float-right">:</a></div>
                                    <div class="col-8"><a class="text-dark" style="font-size:14px">{{ print.batas }}</a></div>
                                </div>

                                <br><br>
                                <div class="row mt-1">
                                    <div class="col-12"><a style="font-size:14px">Dengan ini saya menyatakan bahwa apabila sampai dengan batas waktu tersebut 
                                    ({{ print.batas }}) belum melakukan {{ print.tahapan }} maka saya dianggap mengundurkan diri sebagai mahasiswa 
                                    Institut Teknologi Bandung.</a></div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-12"><a style="font-size:14px">Prodi Magister dan Doktor Teknik Sipil tidak akan mentolerir perpanjangan 
                                    masa studi berikutnya dengan alasan apapun.</a></div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-12"><a style="font-size:14px">Demikian surat pernyataan ini saya buat dengan sebenarnya dan dalam keadaan 
                                    sadar tanpa ada paksaan dari pihak manapun.</a></div>
                                </div>
                                <br><br>
                                <div class="row mt-1">
                                    <div class="col-12"><a style="font-size:14px">Bandung, {{ onlyDate(print.tanggal) }}</a></div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-12"><a style="font-size:14px">Yang membuat pernyataan,</a></div>
                                </div>
                                <br><br>
                                <div class="row mt-1">
                                    <div class="col-12"><a style="font-size:14px">Materai 10000</a></div>
                                </div>
                                <br><br>
                                <div class="row mt-1">
                                    <div class="col-12"><a style="font-size:14px">{{ userdata.name }}</a></div>
                                    <div class="col-12"><a style="font-size:14px">NIM {{ userdata.username }}</a></div>
                                </div>

                                    <div class="d-block mb-1 mt-1 text-center"><a style="font-size:14px">Mengetahui,</a></div>

                                <div class="row mt-3">
                                    <div class="col-6"><a class="text-center" style="font-size:14px">Dosen Wali</a></div>
                                    <div class="col-6"><a class="text-center" style="font-size:14px">Ketua Program Studi,</a></div>
                                </div>
                                <br><br><br><br>
                                <div class="row mt-3">
                                    <div class="col-6"><a class="text-center" style="font-size:14px">{{ print.pembimbing }}</a></div>
                                    <div class="col-6"><a class="text-center" style="font-size:14px">Dr.-Ing. Ir. Ediansjah Zulkifli, S.T., M.T.</a></div>
                                </div>
                            </div>
                        </div>
                </section>
        </vue-html2pdf>  

        <vue-html2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="false"
                :preview-modal="true"
                :paginate-elements-by-height="1400"
                :filename="'undangan_'"
                :pdf-quality="1"
                :manual-pagination="true"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="800px"
                ref="html2PdfUndangan"
            >
                <section slot="pdf-content">
                        <div class="card-body pb-0">
                            <!-- Asal Pendaftar -->
                            <div class="d-block mb-4">
                                <div class="row">
                                    <div class="col-12">
                                        &nbsp;&nbsp;<img style="width:720px" src="https://scola-uploader.sgp1.digitaloceanspaces.com/upload/1b608791482aad97af64496c/Undangan%20Progress%20III%20Vani-1.png">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                    <b><a class="text-dark" style="font-size:17px">Program Studi Magister dan <br> Doktor Teknik Sipil</a></b>
                                    <br>
                                    <a style="font-size:12px">Jalan Ganesha No. 10 Bandung 40132
                                    <br>Telp: +6222 2506445
                                    <br>Fax: +6222 2506445
                                    </a>
                                    </div>
                                </div>
                                <br>

                                <div class="row mt-1">
                                    <div class="col-2"><a style="font-size:14px">No.</a><a class="float-right">:</a></div>
                                    <div class="col-7"><a class="text-dark" style="font-size:14px">{{ undangan.undangan }}</a></div>
                                    <div class="col-3"><a class="text-dark" style="font-size:14px;text-align:right;float:right">{{ onlyDate(undangan.tgl_undangan) }}</a></div>
                                </div>
                                    
                                <div class="row mt-1">
                                    <div class="col-2"><a style="font-size:14px">Lampiran</a><a class="float-right">:</a></div>
                                    <div class="col-10"><a class="text-dark" style="font-size:14px">1 Set</a></div>
                                </div>
                                    
                                <div class="row mt-1">
                                    <div class="col-2"><a style="font-size:14px">Hal</a><a class="float-right">:</a></div>
                                    <div class="col-10"><a class="text-dark" style="font-size:14px">Seminar {{ undangan.id_tahapan }}</a></div>
                                </div>

                                <br>

                                <table border="1" class="col-12">
                                    <tr>
                                        <th>
                                            <div class="h6 text-center font-weight-bold text-dark">UNDANGAN SEMINAR PROGRESS {{ undangan.id_tahapan }}</div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="row mt-1">
                                                <div class="col-2"><a style="font-size:14px">&nbsp;Hari, Tanggal</a><a class="float-right">:</a></div>
                                                <div class="col-10"><a class="text-dark" style="font-size:14px">{{ convertDay(undangan.tanggal) }}</a></div>
                                            </div>
                                            <div class="row mt-1">
                                                <div class="col-2"><a style="font-size:14px">&nbsp;Jam</a><a class="float-right">:</a></div>
                                                <div class="col-10"><a class="text-dark" style="font-size:14px">{{ convertTime(undangan.tanggal) }} WIB</a></div>
                                            </div>
                                            <div class="row mt-1">
                                                <div class="col-2"><a style="font-size:14px">&nbsp;Tempat</a><a class="float-right">:</a></div>
                                                <div class="col-10"><a class="text-dark" style="font-size:14px">T. Sipil - 3215</a></div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="row mt-1">
                                                <div class="col-2"><a style="font-size:14px">&nbsp;Pengutamaan</a><a class="float-right">:</a></div>
                                                <div class="col-10"><a class="text-dark" style="font-size:14px">{{ undangan.pengutamaan }}</a></div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="row mt-1">
                                                <div class="col-2"><a style="font-size:14px">&nbsp;Nama</a><a class="float-right">:</a></div>
                                                <div class="col-4"><a class="text-dark" style="font-size:14px">{{ undangan.name }}</a></div>
                                                <div class="col-2"><a style="border-left:1px black solid;font-size:14px">&nbsp;NIM</a><a class="float-right">:</a></div>
                                                <div class="col-4"><a class="text-dark" style="font-size:14px">{{ undangan.nim }}</a></div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="row mt-1">
                                                <div class="col-3"><a style="font-size:14px">&nbsp;Judul Disertasi</a><a class="float-right">:</a></div>
                                                <div class="col-9"><a class="text-dark" style="font-size:14px">{{ undangan.judul }}</a></div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="row mt-1">
                                                <div class="col-3"><a style="font-size:14px">&nbsp;Tim Penguji</a><a class="float-right">:</a></div>
                                                <div class="col-9"></div>
                                                <div class="col-7"><a class="text-dark" style="font-size:14px">&nbsp;{{ undangan.pembimbing[0] ? undangan.pembimbing[0] : '-' }}</a></div>
                                                <div class="col-5"><a class="text-dark" style="font-size:14px">(Pembimbing 1)</a></div>
                                                <div class="col-7"><a class="text-dark" style="font-size:14px">&nbsp;{{ undangan.pembimbing[1] ? undangan.pembimbing[1] : '-' }}</a></div>
                                                <div class="col-5"><a class="text-dark" style="font-size:14px">(Pembimbing 2)</a></div>
                                                <div class="col-7"><a class="text-dark" style="font-size:14px">&nbsp;{{ undangan.pembimbing[2] ? undangan.pembimbing[2] : '-' }}</a></div>
                                                <div class="col-5"><a class="text-dark" style="font-size:14px">(Pembimbing 3)</a></div>
                                                <div class="col-7"><a class="text-dark" style="font-size:14px">&nbsp;Ir. R. Muslinang Moestopo, M.S.EM, Ph.D.</a></div>
                                                <div class="col-5"><a class="text-dark" style="font-size:14px">(Anggota PPD)</a></div>
                                                <div class="col-7"><a class="text-dark" style="font-size:14px">&nbsp;Dhemi Harlan, Ph.D</a></div>
                                                <div class="col-5"><a class="text-dark" style="font-size:14px">(Koordinator Progress)</a></div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="row mt-1">
                                                <div class="col-3"><a style="font-size:14px">&nbsp;Catatan</a><a class="float-right">:</a></div>
                                                <div class="col-9"></div>
                                                <div class="col-12"><a class="text-dark" style="font-size:14px">&nbsp;Handout materi presentasi mahasiswa harus sudah dibagikan kepada semua penguji paling lambat 
                                                3 hari <br>&nbsp;sebelum seminar dilakukan.</a></div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="row mt-1">
                                                <div class="col-3"><a style="font-size:14px">&nbsp;Yang mengundang</a><a class="float-right">:</a></div>
                                                <div class="col-9"></div>
                                                <div class="col-12"><a class="text-dark" style="font-size:14px">&nbsp;Ketua Program Studi Magister & Doktor T. Sipil</a></div>
                                                &nbsp;&nbsp;<img style="margin-left:10px;width:30%" src="https://scola-uploader.sgp1.digitaloceanspaces.com/upload/0c74180ee5eda8d9ca3c12ae/Undangan%20Progress%20I%20Altho%20edit-1.png">
                                                <div class="col-12"><a class="text-dark" style="font-size:14px">&nbsp;Dr.-Ing. Ir. Ediansjah Zulkifli, S.T., M.T.</a></div>
                                            </div>
                                        </th>
                                    </tr>
                                </table>
                            </div>
                        </div>
                </section>
        </vue-html2pdf> 
    </div>
</template>
<script>
    // @ is an alias to /src
    import { mapState } from 'vuex';
    import moment from 'moment';
    import DatetimePicker from 'vuejs-datetimepicker';
    import VueHtml2pdf from 'vue-html2pdf'

    export default {
        name: 'Beranda',
        components: {
            DatetimePicker,
            VueHtml2pdf,
        },
        metaInfo: {
            title: 'FTSL',
            titleTemplate: '%s - Progress Kemajuan'
        },
        data() {
            return {
                baseUrl: this.$apiconfig,
                search: "",
                listData: [],
                profil: {},
                fetching: true,
                loadAjukan: 0,
                loadLogbook: 0,
                file_logbook: '',
                form: {
                    id : '',
                    tanggal : '',
                    berita_acara : '',
                    logbook_file : '',
                    id_tahapan: '',
                    id_kemajuan: '',
                },
                print: {
                    judul: '',
                    pembimbing: '',
                    studi_berjalan: '',
                    tahapan: '',
                    batas: '',
                    id_tahapan: '',
                    tanggal: '',
                },
                undangan: {
                    name: '',
                    nim: '',
                    judul: '',
                    tahapan: '',
                    pengutamaan: '',
                    id_tahapan: '',
                    tgl_undangan: '',
                    tanggal: '',
                    undangan: '',
                    pembimbing: ''
                }
            }
        },
        mounted() {
            this.$store.dispatch('loadUserData')
        },
        computed: mapState([
            'userdata'
        ]),
        created() {
            this.getData();
            this.getTracer();
        },
        methods: {
            hide_modal() {
                this.$modal.hide('my-modal')
            },
            hide_logbook() {
                this.$modal.hide('my-logbook')
            },
            getTracer: function() {
                this.listData = [];
                this.fetching = true;
                let uri = this.$apiconfig + 'mahasiswa/profil/tracer';
                this.$http.get(uri, {
                    params: {
                        keyword     : '',
                    }
                }).then(res => {					
                    let getResponse = res.data;
                    if (getResponse.status) {
                        this.profil = getResponse.data;
                    }
                    this.fetching = false;
                });
            },
            getData: function() {
                this.listData = [];
                this.fetching = true;
                let uri = this.$apiconfig + 'mahasiswa/kemajuan';
                this.$http.get(uri, {
                    params: {
                        keyword     : '',
                    }
                }).then(res => {					
                    let getResponse = res.data;
                    if (getResponse.status) {
                        this.listData = getResponse.data;
                    } else {
                        this.listData = [];
                    }
                    this.fetching = false;
                });
            },
            uploadFile() {
                const file = this.$refs.fileInput.files[0]; 
                var fsize  = ((file.size/1024)/1024).toFixed(4); // MB
                
                if(fsize >= 5) {
                    alert("File yang di upload tidak boleh lebih 5 MB");
                } else {
                   this.form.berita_acara = this.$refs.fileInput.files[0];
                }
            },
            uploadLogbook() {
                const file = this.$refs.fileLogbook.files[0]; 
                var fsize  = ((file.size/1024)/1024).toFixed(4); // MB
                
                if(fsize >= 5) {
                    alert("File yang di upload tidak boleh lebih 5 MB");
                } else {
                   this.form.logbook_file = this.$refs.fileLogbook.files[0];
                }
            },
            updateProgress(idTahapan, idKemajuan) {
                this.form.id_tahapan = idTahapan;
                this.form.id_kemajuan = idKemajuan;
                this.$modal.show('my-modal');
            },
            updateLogbook(idTahapan, idKemajuan, idLogbook, logbook) {
                this.form.id = idLogbook;
                this.form.id_tahapan = idTahapan;
                this.form.id_kemajuan = idKemajuan;
                this.file_logbook = logbook;
                this.$modal.show('my-logbook');
            },
            convertDate : function (date) {
                return moment(date, 'YYYY-MM-DD hh:mm').lang("id").format('DD MMMM YYYY hh:mm');
            },
            convertTime : function (date) {
                return moment(date, 'YYYY-MM-DD hh:mm').lang("id").format('hh:mm');
            },
            convertDay : function (date) {
                return moment(date, 'YYYY-MM-DD hh:mm').lang("id").format('dddd, DD MMMM YYYY');
            },
            onlyDate : function (date) {
                return moment(date, 'YYYY-MM-DD').lang("id").format('DD MMMM YYYY');
            },
            alertLogbook() {
                this.$swal({
                    icon: 'error',
                    title: "PERINGATAN",
                    text: 'Upload Logbook terlebih dahulu sebelum mendaftar!',
                    showConfirmButton: false,
                    timer: 1500
                })
            },
            async submitForm() {
                this.loadAjukan = 1;
               
                if (!this.form.tanggal) {
                    this.$swal({
                        icon: 'error',
                        title: "Error",
                        text: 'Tanggal harus diisi!',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.loadAjukan = 0;
                    return;
                }
                
                const formData = new FormData();
                formData.append('file', this.form.berita_acara);
                formData.append('tanggal', this.form.tanggal);
                formData.append('id_tahapan', this.form.id_tahapan);
                formData.append('id_kemajuan', this.form.id_kemajuan);

                try {
                    // Simpan data pertama (await digunakan untuk menunggu hasilnya)
                    const response = await this.$http.post(this.baseUrl + 'mahasiswa/kemajuan/save', formData);

                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: "Success",
                            text: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });

                        // Kirim notifikasi secara asynchronous (await untuk menunggu hasil pengiriman notifikasi)
                        try {
                            await this.$http.post(this.baseUrl + 'mahasiswa/kemajuan/send', formData);
                            console.log('Notifikasi terkirim');
                        } catch (error) {
                            console.error('Gagal mengirim notifikasi:', error.response ? error.response.data : error.message);
                        }

                    } else {
                        this.$swal({
                            icon: 'error',
                            title: "Error",
                            text: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }

                    this.$modal.hide('my-modal');
                    this.loadAjukan = 0;
                    this.getData();
                    this.resetForm();

                } catch (error) {
                    console.error('Gagal menyimpan data:', error.response ? error.response.data : error.message);
                }
            },

            resetForm() {
                this.form.id = '';
                this.form.tanggal = '';
                this.form.berita_acara = '';
                this.form.id_tahapan = '';
                this.form.id_pengajuan = '';
            },

            submitLogbook() {
                this.loadLogbook = 1;
                const formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('file', this.form.logbook_file);
                formData.append('id_tahapan', this.form.id_tahapan);
                formData.append('id_kemajuan', this.form.id_kemajuan);

                this.$http.post(this.baseUrl + 'mahasiswa/kemajuan/save_logbook', formData)
                    .then((response) => {
                        if(response.data.status){
                            this.$swal({
                                icon: 'success',
                                title: "success",
                                text: response.data.message,
                                showConfirmButton: false,
                                timer: 1500
                            })
                        }else{
                            this.$swal({
                                icon: 'error',
                                title: "Error",
                                text: response.data.message,
                                showConfirmButton: false,
                                timer: 1500
                            })
                        }
                        
                        this.$modal.hide('my-logbook')
                        this.loadLogbook = 0;
                        this.getData()
                        this.form.id = ''
                        this.form.logbook_file = ''
                        this.form.id_tahapan = ''
                        this.form.id_pengajuan = ''
                    })
                    .catch(error => {
                        console.log(error.response.data)
                    });
            },
            uploadFoto() {
                const file = this.$refs.fileInput.files[0]; 
                var fsize  = ((file.size/1024)/1024).toFixed(4); // MB
                
                if(fsize >= 1) {
                    alert("File yang di upload tidak boleh lebih 5 MB");
                } else {
                   this.form.berita_acara = this.$refs.fileInput.files[0];
                }
            },
            generateReport () {
                this.$refs.html2Pdf.generatePdf()
            },
            generateUndangan () {
                this.$refs.html2PdfUndangan.generatePdf()
            },
            updateSurat (id) {
                let uri = this.$apiconfig + 'mahasiswa/kemajuan/print';
                this.$http.get(uri, {
                    params: {
                        id     : id,
                    }
                }).then(res => {					
                    let getResponse = res.data;
                    this.print.judul = getResponse.data.judul;
                    this.print.pembimbing = getResponse.data.pembimbing[0] ? getResponse.data.pembimbing[0] : '';
                    this.print.tahapan = getResponse.data.name;
                    this.print.batas = getResponse.data.batas_studi;
                    this.print.studi_berjalan = getResponse.data.progress_studi;
                    this.print.id_tahapan = getResponse.data.id_tahapan;
                    this.print.tanggal = getResponse.data.created_at;
                });
            },
            updateUndangan (id) {
                let uri = this.$apiconfig + 'mahasiswa/kemajuan/undangan';
                this.$http.get(uri, {
                    params: {
                        id     : id,
                    }
                }).then(res => {					
                    let getResponse = res.data;
                    this.undangan.name = getResponse.data.fullname;
                    this.undangan.nim = getResponse.data.username;
                    this.undangan.undangan = getResponse.data.undangan;
                    this.undangan.judul = getResponse.data.judul;
                    this.undangan.pembimbing = getResponse.data.pembimbing;
                    this.undangan.tahapan = getResponse.data.name;
                    this.undangan.pengutamaan = getResponse.data.pengutamaan;
                    this.undangan.id_tahapan = getResponse.data.id_tahapan;
                    this.undangan.tgl_undangan = getResponse.data.tgl_undangan;
                    this.undangan.tanggal = getResponse.data.tanggal;
                });
            },
        }
    }
</script>